// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1UserSchema } from './v1/userSchema';

export const listUsersPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
});

export const listUsersQueryParamsSchema = z.object({
  limit: z.optional(z.number().int().describe("Maximum number of results to return")),
  offset: z.optional(z.number().int().describe("Number of results to skip")),
  order: z.optional(z.coerce.string().describe("Sort order")),
  filter: z.optional(z.enum(["deleted"]).describe("Filter for deleted users")),
}).optional();

export const listUsersHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description users list
 */
export const listUsers200Schema = z.array(z.lazy(() => v1UserSchema));

export const listUsersQueryResponseSchema = z.lazy(() => listUsers200Schema);
